import {
	RETRIEVED,
	GET_PAGE,
	GET_NAVIGATION,
	GET_PRODUCT_LIST,
	GET_PRODUCT,
	SET_QUERY,
	GET_SHOPIFY_CLIENT,
	GET_SHOPIFY_PRODUCT_LIST,
	GET_SHOP_INFO,
	GET_SHOPIFY_CART,
	ADD_TO_BAG,
	SHOW_BAG_POPUP,
	HIDE_BAG_POPUP,
	UPDATE_BAG,
	SLIDE_PRODUCT_IMAGE,
	FILTER_PRODUCTS,
	CHANGE_SLIDE,
	WINDOW_DIMENSIONS,
	TOGGLE_PRODUCT_PROPERTY,
	TOGGLE_PRODUCT_HOVER,
	PREVIOUS_PAGE,
} from '../actions/environment';

const initialState = {
	retrieved: [],
	pages: {},
	productList: {},
	previousPage: '/shop',
	products: {},
	variables: {
		otherVariantsOpen: false,
	},
	shop: {
		showPopup: false,
		currencyFormat: '{{}}',
		checkout: {
			ID: '',
			currency: '',
			location: '',
			items: {}, /* [productID]: quantity:int */
			totals: {
				subTotalPrice: '',
				totalPrice: '',
				totalTax: '',
			},
		},
	},
	setup: {},
	navigation: {},
	win: {},
};

const environment = (state = initialState, action) => {
	switch (action.type) {
		case RETRIEVED:
			return {
				...state,
				retrieved: [
					...state.retrieved,
					action.route,
				],
			};

		case GET_PAGE:
			return {
				...state,
				pages: {
					...state.pages,
					[action.page]: { ...action.data },
				},
			};

		case GET_PRODUCT_LIST:
			return {
				...state,
				productList: {
					filter: '',
					count: action.data.content.count,
					productOrder: [...action.data.content.productOrder],
					products: { ...action.data.content.products },
					showingProducts: { ...action.data.content.products },
					submenu: { ...action.data.content.submenu },
				},
			};

		case GET_SHOPIFY_PRODUCT_LIST:
			return {
				...state,
				productList: {
					...state.productList,
					availability: { ...action.products },
				},
			};

		case FILTER_PRODUCTS:
			return {
				...state,
				productList: {
					...state.productList,
					filter: action.filter,
					showingProducts: { ...action.products },
				},
			};

		case GET_PRODUCT:
			return {
				...state,
				products: {
					...state.products,
					[action.data.content.product.URI]: {
						...action.data.content,
						slideIndex: 0,
					},
				},
			};

		case SLIDE_PRODUCT_IMAGE:
			return {
				...state,
				products: {
					...state.products,
					[action.uri]: {
						...state.products[action.uri],
						slideIndex: action.index,
					},
				},
			};

		case TOGGLE_PRODUCT_PROPERTY: {
			if (action.property === 'otherVariantsOpen') {
				return {
					...state,
					variables: {
						...state.variables,
						otherVariantsOpen: !state.variables.otherVariantsOpen,
					},
				};
			}
			return {
				...state,
				products: {
					...state.products,
					[action.uri]: {
						...state.products[action.uri],
						openProperty: (state.products[action.uri].openProperty === action.property ? '' : action.property),
					},
				},
			};
		}

		case GET_NAVIGATION:
			return {
				...state,
				setup: {
					...state.setup,
					siteClosed: action.data.setup.siteClosed,
					shopClosed: action.data.setup.shopClosed,
					meta: { ...action.data.setup.meta },
					static: { ...action.data.setup.static },
					keys: { ...action.data.setup.keys },
				},
				navigation: {
					...state.navigation,
					shopMenu: [...action.data.navigation.shopMenu],
					footer: [...action.data.navigation.footer],
					social: [...action.data.navigation.social],
					sideMenu: [...action.data.navigation.sideMenu],
					sideMenuOpen: false,
					sideSubMenuOpen: false,
				},
			};

		case SET_QUERY:
			return {
				...state,
				setup: {
					...state.setup,
					preview: action.query,
				},
			};

		case GET_SHOPIFY_CLIENT:
			return {
				...state,
				shop: {
					...state.shop,
					shopify: action.client,
				},
			};

		case GET_SHOP_INFO:
			return {
				...state,
				shop: {
					...state.shop,
					currencyFormat: action.shop.moneyFormat,
				},
			};

		case GET_SHOPIFY_CART:
			return {
				...state,
				shop: {
					...state.shop,
					checkout: {
						...state.shop.checkout,
						ID: action.checkoutID,
						location: action.cart.webUrl,
						items: {
							...state.shop.checkout.items,
							...action.items,
						},
						currency: action.cart.currencyCode,
						totals: {
							subTotalPrice: action.cart.subtotalPrice,
							totalPrice: action.cart.totalPrice,
							totalTax: action.cart.totalTax,
						},
					},
				},
			};

		case ADD_TO_BAG:
			return {
				...state,
				shop: {
					...state.shop,
					showPopup: true,
					checkout: {
						...state.shop.checkout,
						ID: action.checkoutID,
						location: action.location,
						items: {
							...action.items,
						},
						totals: {
							subTotalPrice: action.cart.subtotalPrice,
							totalPrice: action.cart.totalPrice,
							totalTax: action.cart.totalTax,
						},
					},
				},
			};

		case UPDATE_BAG:
			return {
				...state,
				shop: {
					...state.shop,
					checkout: {
						...state.shop.checkout,
						items: {
							...action.items,
						},
						totals: {
							subTotalPrice: action.cart.subtotalPrice,
							totalPrice: action.cart.totalPrice,
							totalTax: action.cart.totalTax,
						},
					},
				},
			};

		case SHOW_BAG_POPUP:
			return {
				...state,
				shop: {
					...state.shop,
					showPopup: !state.shop.showPopup,
				},
			};

		case HIDE_BAG_POPUP:
			return {
				...state,
				shop: {
					...state.shop,
					showPopup: false,
				},
			};

		case CHANGE_SLIDE:
			return {
				...state,
				pages: {
					...state.pages,
					[action.contentKey]: {
						...state.pages[action.contentKey],
						content: {
							...state.pages[action.contentKey].content,
							startSliderIndex: state.pages[action.contentKey].content.startSliderIndex + 1,
						},
					},
				},
			};

		case WINDOW_DIMENSIONS:
			return {
				...state,
				win: {
					...state.win,
					width: action.width,
					height: action.height,
				},
			};

		case TOGGLE_PRODUCT_HOVER:
			return {
				...state,
				productList: {
					...state.productList,
					showingProducts: {
						...state.productList.showingProducts,
						[action.id]: {
							...state.productList.showingProducts[action.id],
							hovering: state.productList.showingProducts[action.id].hovering === undefined || state.productList.showingProducts[action.id].hovering === false,
						},
					},
				},
			};

		case PREVIOUS_PAGE:
			return {
				...state,
				previousPage: action.page,
			};

		default:
			return state;
	}
};

export default environment;



// WEBPACK FOOTER //
// ./reducers/environment.js